import { HTMLAttributes, useEffect } from 'react';
import { useMeasure } from 'react-use';
import type { SafeAny } from '@trg/utils';
import { ApiContextProvider } from '@trg/api';
import { Header } from '../../header';
import {
  createReactApp,
  createTailwindLink,
  registerCustomElement,
} from '../utils';

const CUSTOM_HEADER_TAG_NAME = 'custom-header';

class CostomHeader extends HTMLElement {
  constructor() {
    super();

    this.attachShadow({ mode: 'open' });
  }

  connectedCallback() {
    if (!this.shadowRoot) return;

    const tailwindLink = createTailwindLink({
      environment: process.env['NODE_ENV'] as SafeAny,
    });
    this.shadowRoot.appendChild(tailwindLink);

    createReactApp(
      this.shadowRoot,
      <ApiContextProvider value={{ host: process.env['TLW_API_HOST'] }}>
        <Header />
      </ApiContextProvider>
    );
  }
}

export type NewHeaderProps = Omit<HTMLAttributes<HTMLElement>, 'children'> & {
  compatibleMode?: boolean;
};

export function NewHeader({ compatibleMode, style, ...props }: NewHeaderProps) {
  const [ref, { height }] = useMeasure<HTMLElement>();

  useEffect(() => {
    const body = document.body;
    if (compatibleMode) {
      body.style.paddingTop = `${height}px`;
    } else {
      body.style.paddingTop = '0';
    }
  }, [height, compatibleMode]);

  registerCustomElement(CUSTOM_HEADER_TAG_NAME, CostomHeader);

  return (
    <custom-header
      ref={ref}
      part="NoHeader"
      style={{
        position: compatibleMode ? 'fixed' : 'sticky',
        top: '0',
        left: '0',
        right: '0',
        zIndex: '100',
        ...style,
      }}
      {...props}
    />
  );
}
